import React, { useState } from 'react';
import { FaTimes, FaRegCalendar, FaChevronLeft, FaChevronRight, FaRegClock } from 'react-icons/fa';
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

function TimeRangeSelector({ isOpen, onClose, onApply }) {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState([4, 8]);
    const [timeFormat, setTimeFormat] = useState('AM');
  
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    const handlePrevMonth = () => {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1));
    };
  
    const handleNextMonth = () => {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1));
    };

    const generateCalendarDays = () => {
      const firstDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
      const lastDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
      const days = [];
      
      // Add previous month's days
      for (let i = 0; i < firstDay.getDay(); i++) {
        const prevMonthLastDay = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 0);
        days.push({
          date: prevMonthLastDay.getDate() - firstDay.getDay() + i + 1,
          isCurrentMonth: false
        });
      }

      // Add current month's days
      for (let i = 1; i <= lastDay.getDate(); i++) {
        days.push({
          date: i,
          isCurrentMonth: true
        });
      }
      
      // Add next month's days
      const remainingDays = 42 - days.length;
      for (let i = 1; i <= remainingDays; i++) {
        days.push({
          date: i,
          isCurrentMonth: false
        });
      }
      
      return days;
    };

    const handleSelectedTime = (time) => {
      setSelectedTime(time);
    };  
  
    if (!isOpen) return null;
  
    return (
      <div className="time-range-overlay">
        <div className="time-range-modal">
          <div className="time-range-header">
            <h3>Select Time Range</h3>
            <button className="close-button" onClick={onClose}>
              <FaTimes />
            </button>
          </div>
          
          <div className="time-range-content">
            <div className="date-picker">
              <div className="section-title">
                <FaRegCalendar />
                <span>Confirm Date</span>
              </div>
              
              <div className="calendar-header">
                <button onClick={handlePrevMonth}><FaChevronLeft /></button>
                <span>{months[selectedDate.getMonth()]} {selectedDate.getFullYear()}</span>
                <button onClick={handleNextMonth}><FaChevronRight /></button>
              </div>
              
              <div className="calendar-grid">
                <div className="weekdays">
                  <div>Su</div>
                  <div>Mo</div>
                  <div>Tu</div>
                  <div>We</div>
                  <div>Th</div>
                  <div>Fr</div>
                  <div>Sa</div>
                </div>
                <div className="days">
                  {generateCalendarDays().map((day, index) => (
                    <div
                      key={index}
                      className={`day ${!day.isCurrentMonth ? 'other-month' : ''}`}
                      onClick={() => day.isCurrentMonth && setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), day.date))}
                    >
                      {day.date}
                    </div>
                  ))}
                </div>
              </div>
            </div>
  
            <div className="time-picker">
              <div className="section-title">
                <FaRegClock />
                <span>Confirm Time</span>
              </div>
              
              <div className="time-selector">
                <div className="time-header">
                  <button 
                    onClick={() => setTimeFormat('AM')}
                    style={{ color: timeFormat === 'AM' ? '#7CC644' : '#fff' }}
                  >
                    AM
                  </button>
                  <button 
                    onClick={() => setTimeFormat('PM')}
                    style={{ color: timeFormat === 'PM' ? '#7CC644' : '#fff' }}
                  >
                    PM
                  </button>
                </div>
              <div>
                <Slider
                  range
                  min={0}
                  max={12}
                  step={1}
                  value={selectedTime}
                  onChange={handleSelectedTime}
                  marks={{
                      0: "0:00",
                      1: "1:00",
                      2: "2:00",
                      3: "3:00",
                      4: "4:00",
                      5: "5:00",
                      6: "6:00",
                      7: "7:00",
                      8: "8:00",
                      9: "9:00",
                      10: "10:00",
                      11: "11:00",
                      12: "12:00",
                  }}
                  allowCross={false}
                  styles={{
                      track: { backgroundColor: "#7CC644" },
                      rail: { backgroundColor: "#7CC64433" },
                      handle: {
                          borderColor: "#7CC644",
                          backgroundColor: "#fff",
                          boxShadow: "0 0 0 2px #7CC64433",
                      },
                  }}
              />
              </div>
              </div>
            </div>
          </div>
  
          <div className="time-range-footer">
            <button className="cancel-button" onClick={onClose}>Cancel</button>
            <button 
              className="apply-button" 
              onClick={() => {
                onApply({ date: selectedDate, time: selectedTime, format: timeFormat });
                onClose();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    );
  }

export default TimeRangeSelector; 